import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Typography } from '@mui/material';

interface GrouperSelectProps {
    grouperCode: string;
    availableGroupers: Array<{
        code: string;
        rate: number;
        isPerDiem: boolean;
    }>;
    error?: string;
    onChange: (value: string) => void;
}

export const GrouperSelect: React.FC<GrouperSelectProps> = ({
    grouperCode,
    availableGroupers,
    error,
    onChange
}) => {
    return (
        <FormControl size="small" fullWidth error={!!error}>
            <InputLabel>Grouper Code</InputLabel>
            <Select
                value={grouperCode}
                label="Grouper Code"
                onChange={(e) => onChange(e.target.value)}
            >
                {availableGroupers.map((grouper) => (
                    <MenuItem key={grouper.code} value={grouper.code}>
                        {grouper.code} - ${grouper.rate.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                        {grouper.isPerDiem ? ' (Per Diem)' : ''}
                    </MenuItem>
                ))}
            </Select>
            {error && (
                <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.75 }}>
                    {error}
                </Typography>
            )}
        </FormControl>
    );
};
